import styled from 'styled-components';
import { Button } from 'grommet';
import { FileCopy } from '@material-ui/icons';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  gap: 4px;
  height: calc(100vh - 100px);
  background-color: white;
  overflow: hidden;

  @media (max-width: 1024px) {
    flex-direction: column;
    height: 100%;
    gap: 16px;
  }

  @media (max-width: 1024px) and (max-height: 800px) {
    height: auto;
    min-height: 100%;
    overflow-y: auto;
  }

  @media (max-width: 768px) {
    gap: 12px;
  }

  @media (min-width: 1200px) {
    height: calc(100vh - 60px);
  }

  @media (min-width: 1440px) {
    height: calc(100vh - 40px);
  }

  @media (min-width: 1920px) {
    height: calc(100vh - 20px);
  }
  @media (min-width: 2560px) {
    height: calc(100vh - 10px);
  }
`;

export const LeftSection = styled.div`
  flex: 2;
  min-width: 500px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  padding: 0 25px 0 30px;
  gap: 8px;
  background-color: white;
  height: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
  scrollbar-width: thin;
  scrollbar-color: #c1c1c1 transparent;

  /* Webkit scrollbar styling for consistent appearance */
  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
  }

  @media (max-width: 1024px) {
    flex: none;
    width: 100%;
    min-width: unset;
    height: auto;
    overflow: visible;
    padding: 0 20px 0 20px;
  }

  @media (max-width: 1024px) and (max-height: 800px) {
    min-height: 300px;
    max-height: 400px;
    overflow-y: auto;
  }

  @media (max-width: 768px) {
    padding: 16px 20px;
    gap: 16px;
  }

  @media (max-width: 480px) {
    padding: 12px 16px;
    gap: 12px;
  }

  @media (min-width: 1440px) {
    padding: 0 25px 10px 40px;
  }

  @media (min-width: 1920px) {
    padding: 0 30px 30px 60px;
  }
  @media (min-width: 2560px) {
    padding: 0 40px 30px 80px;
  }
`;

export const SubscribersDashboardWrapper = styled.div`
  margin: 0 -15px; /* pull it out to the edges */
`;

export const RightSection = styled.div`
  flex: 1;
  min-width: 350px;
  max-width: 800px;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  height: 100%;
  overflow-y: visible;
  overflow-x: hidden;
  padding: 0 25px 0 5px;

  @media (max-width: 1024px) {
    flex: none;
    height: auto;
    overflow: visible;
    padding: 0 30px 0 5px;
  }

  @media (max-width: 1024px) and (max-height: 800px) {
    min-height: 300px;
    max-height: 400px;
    overflow-y: auto;
  }

  @media (max-width: 768px) {
    height: auto;
    overflow: visible;
    min-height: 250px;
    padding: 0 16px 0 7px;
  }

  @media (max-width: 480px) {
    padding: 0 12px 0 3px;
  }

  @media (min-width: 1440px) {
    padding: 0 30px 0 5px;
    overflow-y: visible;
  }

  @media (min-width: 1440px) {
    padding: 0 30px 0 5px;
    overflow-y: visible;
    flex: 1.1;
  }

  @media (min-width: 1920px) {
    padding: 0 50px 0 20px;
    overflow-y: visible;
    flex: 1.2;
    min-width: 400px;
  }
  @media (min-width: 2560px) {
    padding: 0 70px 0 30px;
    overflow-y: visible;
    flex: 1.3;
    min-width: 450px;
  }

  @media (min-width: 1200px) and (max-height: 800px) {
    overflow-y: visible;
    flex: 1.2;
  }
`;

export const URLContainer = styled.div`
  border: 1px solid rgba(0, 0, 0, 0.4);
  border-radius: 13px;
  padding: 5px 10px;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.6);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-family: monospace;
  flex: 1;

  @media (max-width: 768px) {
    font-size: 11px;
    padding: 4px 8px;
  }

  @media (max-width: 480px) {
    font-size: 10px;
    padding: 3px 6px;
  }
`;

export const EmbedCodeContainer = styled.div`
  border: 1px solid rgba(0, 0, 0, 0.4);
  border-radius: 13px;
  padding: 10px 12px;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.6);
  cursor: pointer;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  font-family: monospace;
  flex: 1;
  min-height: 75px;
  white-space: pre-wrap;
  overflow-y: auto;
  overflow-x: hidden;
  word-break: break-all;
  cursor: pointer;

  @media (max-width: 768px) {
    font-size: 11px;
    padding: 8px 10px;
    min-height: 70px;
  }

  @media (max-width: 480px) {
    font-size: 10px;
    padding: 6px 8px;
    min-height: 60px;
  }
`;

// New styled components for inline styles
export const MainTitle = styled.div`
  font-family: 'Poppins';
  font-weight: 500;
  font-size: 26px;
  color: #212121;

  margin: 0;
  padding: 0;

  @media (max-width: 768px) {
    font-size: 22px;
  }

  @media (max-width: 480px) {
    font-size: 20px;
  }
`;

export const MainDescription = styled.p`
  font-family: 'Poppins';
  font-weight: 400;
  font-size: 16px;

  color: #9b9b9b;
  margin: 4px 0;

  @media (max-width: 768px) {
    font-size: 14px;
  }

  @media (max-width: 480px) {
    font-size: 13px;
  }
`;

export const Divider = styled.hr`
  border: none;
  border-top: 1px solid #e0e0e0;
  margin: 18px 0 18px 0;
`;

export const SectionTitle = styled.div`
  font-family: 'Poppins';
  font-weight: 500;
  font-style: normal;
  font-size: 26px;

  color: #8e8e8e;
  margin-bottom: 20px;

  @media (max-width: 768px) {
    font-size: 22px;
    margin-bottom: 20px;
  }

  @media (max-width: 480px) {
    font-size: 20px;
    margin-bottom: 16px;
  }
`;

export const IconTitleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;

  @media (max-width: 480px) {
    gap: 6px;
  }
`;

export const IconTitle = styled.div`
  font-family: 'Poppins';
  font-weight: 500;
  font-style: normal;
  font-size: 18px;

  color: #212121;

  @media (max-width: 768px) {
    font-size: 15px;
  }

  @media (max-width: 480px) {
    font-size: 13px;
  }
`;

export const SectionDescription = styled.p`
  font-family: 'Poppins';
  font-weight: 400;
  font-size: 16px;

  color: #9b9b9b;
  margin: 0;

  @media (max-width: 768px) {
    font-size: 14px;
  }

  @media (max-width: 480px) {
    font-size: 13px;
  }
`;

export const OptInEditorWrapper = styled.div`
  margin: 0 -5px; /* pulls it outward, just like SubscribersDashboard */
`;

export const FooterContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 25px;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 12px;
    align-items: flex-start;
  }

  @media (max-width: 480px) {
    gap: 10px;
    margin-bottom: 20px;
  }
`;

export const FooterNote = styled.p`
  font-family: 'Poppins';
  font-weight: 400;
  font-style: normal;
  font-size: 16px;

  color: #9b9b9b;
  margin: 0;

  @media (max-width: 768px) {
    font-size: 14px;
  }

  @media (max-width: 480px) {
    font-size: 13px;
  }
`;

export const FooterLink = styled.span`
  color: #9b9b9b;
  text-decoration: underline;
  cursor: pointer;
  font-size: 14px;
`;

export const SaveButton = styled(Button)`
  background: #007ade;
  color: #ffffff;
  border-color: #007ade;
  padding: 2px 30px;
  border-radius: 5px;
  font-size: 12px;
  text-transform: none;
  min-width: unset;

  &:disabled {
    background: #d3d3d3 !important;
    color: #ffffff !important;
    cursor: default !important;
    opacity: 1 !important;
  }

  @media (max-width: 768px) {
    padding: 6px 10px;
    font-size: 13px;
  }

  @media (max-width: 480px) {
    padding: 4px 8px;
    font-size: 12px;
  }
`;

export const SectionDivider = styled.hr`
  border: none;
  border-top: 1px solid #e0e0e0;
  margin-top: 40px;

  @media (max-width: 768px) {
    margin-top: 30px;
  }

  @media (max-width: 480px) {
    margin-top: 25px;
  }
`;

export const CopyUrlSection = styled.div`
  margin-bottom: 20px;

  @media (max-width: 768px) {
    margin-bottom: 20px;
  }

  @media (max-width: 480px) {
    margin-bottom: 16px;
  }
`;

export const CopyUrlTitle = styled.p`
  font-family: 'Poppins', sans-serif;
  font-weight: 500;
  font-size: 16px;
  color: #212121;
  margin: 0;

  @media (max-width: 768px) {
    font-size: 16px;
  }

  @media (max-width: 480px) {
    font-size: 15px;
  }
`;

export const UrlContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  @media (max-width: 480px) {
    gap: 6px;
  }
`;

export const EmbedCodeTitle = styled.p`
  font-family: 'Poppins', sans-serif;
  font-weight: 500;
  font-size: 16px;
  color: #212121;
  margin: 0;

  @media (max-width: 768px) {
    font-size: 16px;
  }

  @media (max-width: 480px) {
    font-size: 15px;
  }
`;

export const EmbedCodeWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 6px;

  @media (max-width: 480px) {
    gap: 6px;
  }
`;

export const EmbedCodeContent = styled.div`
  flex: 1;
  word-break: break-all;
  white-space: pre-wrap;
  padding-right: 8px;

  @media (max-width: 768px) {
    padding-right: 6px;
  }

  @media (max-width: 480px) {
    padding-right: 20px;
  }
`;

export const CopyIcon = styled(FileCopy)`
  font-size: 14px;
  color: #007ade;
  position: absolute;
  top: 8px;
  right: 8px;
  flex-shrink: 0;

  @media (max-width: 768px) {
    font-size: 14px;
    top: 6px;
    right: 6px;
  }

  @media (max-width: 480px) {
    font-size: 12px;
    top: 4px;
    right: 4px;
  }
`;

export const BottomDivider = styled.hr`
  border: none;
  border-top: 1px solid #e0e0e0;
  margin: 24px 0 0 0;

  @media (max-width: 768px) {
    margin: 20px 0 0 0;
  }

  @media (max-width: 480px) {
    margin: 16px 0 0 0;
  }
`;

export const PreviewContainer = styled.div`
  width: 100%;
  max-height: calc(100vh - 10px);
  height: 100%;
  background: #fff;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  color: #9b9b9b;
  font-family: 'Poppins', sans-serif;
  font-size: 18px;
  overflow: hidden;
  border-radius: 8px;

  @media (max-width: 1024px) {
    max-width: 100%;
    height: fit-content;
  }

  @media (max-width: 1024px) and (max-height: 800px) {
    min-height: 250px;
    max-height: 300px;
    overflow-y: auto;
  }

  @media (max-width: 768px) {
    height: fit-content;
    font-size: 16px;
    border-radius: 8px;
  }

  @media (max-width: 480px) {
    height: fit-content;
    font-size: 14px;
    border-radius: 6px;
  }

  @media (max-width: 320px) {
    height: fit-content;
    font-size: 12px;
    border-radius: 6px;
  }
`;

export const PreviewHeading = styled.h3`
  font-family: 'Poppins';
  font-weight: 500;
  font-style: normal;
  font-size: 26px;

  color: #8e8e8e;
  margin: 0 0 16px 0;
  padding: 0;
  text-align: left;
`;

export const PreviewContent = styled.div`
  width: 100%;
  height: fit-content;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding: 0;
`;

export const PreviewFormContainer = styled.div`
  flex: 1;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  overflow-y: auto;
  overflow-x: hidden;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
  padding: 16px;
  margin-top: 0;
`;
